import { NgModule } from "@angular/core";
import { PoModule } from "@po-ui/ng-components";
import { PoPageChangePasswordModule, PoPageLoginModule } from "@po-ui/ng-templates";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { PasswordRecoveryComponent } from "./password-recovery.component";

@NgModule({
    declarations: [PasswordRecoveryComponent],
    exports: [PasswordRecoveryComponent],
    imports: [
        CommonModule,
        PoModule,
        PoPageChangePasswordModule,
        FormsModule
    ]
})
export class PasswordRecoveryModule {

}